import { useState } from 'react';
import { LessonHeader } from './LessonHeader';
import { primaryBtn, screenShell } from './common';
import { ErrorState, LoadingState } from '../../components/ScreenState';
import { SpeakButton } from '../../components/SpeakButton';
import { ttsTextOf } from '../../components/speech';
import { useAsync } from '../../hooks/useAsync';
import { contentApi } from '../../api/content';
import type { LessonScreenProps } from './types';

export function KanaIntroScreen({ lessonId, unitName, lessonName, onBack, onNext }: LessonScreenProps) {
  const lesson = useAsync(() => contentApi.getLesson(lessonId), [lessonId]);
  const [index, setIndex] = useState(0);

  if (lesson.loading) return <LoadingState />;
  if (lesson.error || !lesson.data) return <ErrorState message="Không tải được bài học." />;

  const items = lesson.data.items.filter((it) => it.itemType === 'KANA');
  const item = items[index];
  if (!item || item.itemType !== 'KANA') return <ErrorState message="Bài học này chưa có nội dung Kana." />;

  const next = () => {
    if (index < items.length - 1) setIndex(index + 1);
    else onNext();
  };

  return (
    <div style={screenShell}>
      <LessonHeader onBack={onBack} ctx={{ track: 'kana', unit: unitName, lesson: lessonName, step: 1, total: 2 }} />
      <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, padding: 24 }}>
        <div style={{ fontFamily: 'var(--font-jp)', fontSize: 120, fontWeight: 400, lineHeight: 1, color: 'var(--ink)' }}>{item.character}</div>
        {item.romaji && <div style={{ fontSize: 20, color: 'var(--text-secondary)', letterSpacing: 1, marginTop: -8 }}>{item.romaji}</div>}
        <SpeakButton text={ttsTextOf(item)} size={56} />
        {item.meaningVi && (
          <div style={{ width: '100%', marginTop: 12, background: 'rgba(179,205,224,0.25)', borderRadius: 'var(--radius-card)', padding: 16, fontSize: 16, color: 'var(--ink)', lineHeight: 1.5 }}>
            {item.meaningVi}
          </div>
        )}
        <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginTop: 12 }}>{`${index + 1}/${items.length}`}</div>
      </div>
      <div style={{ padding: 20, borderTop: '1px solid var(--border-default)' }}>
        <button onClick={next} style={primaryBtn}>
          Tiếp theo
        </button>
      </div>
    </div>
  );
}
